import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { createpayslip, liststaff, viewpayslip } from "../../../services/admin";
import { toast } from "react-toastify";
import Select from "react-select";

export default function AddPayslip() {
    const navigate = useNavigate();
    const { id } = useParams();

    const [staffList, setStaffList] = useState([]);
    const [formData, setFormData] = useState({
        id: 0,
        staff_id: "",
        month: "",
        year: new Date().getFullYear(),
        basic_salary: "",
        hra: 0,
        transport_allowance: 0,
        medical_allowance: 0,
        other_allowances: 0,
        provident_fund: 0,
        tax_deduction: 0,
        other_deductions: 0,
        gross_salary: 0,
        total_deductions: 0,
        net_salary: 0,
        remarks: "",
        status: "generated",
        payment_date: "",
    });

    const months = [
        { value: "January", label: "January" },
        { value: "February", label: "February" },
        { value: "March", label: "March" },
        { value: "April", label: "April" },
        { value: "May", label: "May" },
        { value: "June", label: "June" },
        { value: "July", label: "July" },
        { value: "August", label: "August" },
        { value: "September", label: "September" },
        { value: "October", label: "October" },
        { value: "November", label: "November" },
        { value: "December", label: "December" },
    ];

    useEffect(() => {
        // Fetch staff list
        liststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                const staffOptions = res.data.details.map((staff) => ({
                    value: staff.id,
                    label: `${staff.staff_name} (${staff.staff_code})`,
                }));
                setStaffList(staffOptions);
            }
        });

        // If editing, fetch payslip data
        if (id) {
            viewpayslip(id).then((res) => {
                if (res.status === true) {
                    const data = res.data.details;
                    setFormData({
                        id: data.id,
                        staff_id: data.staff_id,
                        month: data.month,
                        year: data.year,
                        basic_salary: data.basic_salary,
                        hra: data.hra,
                        transport_allowance: data.transport_allowance,
                        medical_allowance: data.medical_allowance,
                        other_allowances: data.other_allowances,
                        provident_fund: data.provident_fund,
                        tax_deduction: data.tax_deduction,
                        other_deductions: data.other_deductions,
                        gross_salary: data.gross_salary,
                        total_deductions: data.total_deductions,
                        net_salary: data.net_salary,
                        remarks: data.remarks || "",
                        status: data.status,
                        payment_date: data.payment_date || "",
                    });
                }
            });
        }
    }, [id]);

    useEffect(() => {
        calculateSalary();
    }, [
        formData.basic_salary,
        formData.hra,
        formData.transport_allowance,
        formData.medical_allowance,
        formData.other_allowances,
        formData.provident_fund,
        formData.tax_deduction,
        formData.other_deductions,
    ]);

    const calculateSalary = () => {
        const basicSalary = parseFloat(formData.basic_salary) || 0;
        const hra = parseFloat(formData.hra) || 0;
        const transportAllowance = parseFloat(formData.transport_allowance) || 0;
        const medicalAllowance = parseFloat(formData.medical_allowance) || 0;
        const otherAllowances = parseFloat(formData.other_allowances) || 0;
        const providentFund = parseFloat(formData.provident_fund) || 0;
        const taxDeduction = parseFloat(formData.tax_deduction) || 0;
        const otherDeductions = parseFloat(formData.other_deductions) || 0;

        const grossSalary = basicSalary + hra + transportAllowance + medicalAllowance + otherAllowances;
        const totalDeductions = providentFund + taxDeduction + otherDeductions;
        const netSalary = grossSalary - totalDeductions;

        setFormData((prev) => ({
            ...prev,
            gross_salary: grossSalary.toFixed(2),
            total_deductions: totalDeductions.toFixed(2),
            net_salary: netSalary.toFixed(2),
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleStaffChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            staff_id: selectedOption.value,
        }));
    };

    const handleMonthChange = (selectedOption) => {
        setFormData((prev) => ({
            ...prev,
            month: selectedOption.value,
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        if (!formData.staff_id) {
            toast.error("Please select a staff member");
            return;
        }
        if (!formData.month) {
            toast.error("Please select a month");
            return;
        }
        if (!formData.year) {
            toast.error("Please enter a year");
            return;
        }
        if (!formData.basic_salary || formData.basic_salary <= 0) {
            toast.error("Please enter a valid basic salary");
            return;
        }

        createpayslip(formData).then((res) => {
            if (res.status === true) {
                toast.success(res.message);
                navigate("/payslip/allpayslip");
            }
        });
    };

    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Generate Payslip</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a> Payslip</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Generate Payslip
                    </li>
                </ol>
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-6">
                                        <h4 className="card-title">
                                            {id ? "Edit Payslip" : "Generate Payslip"}
                                        </h4>
                                    </div>
                                    <div className="col-6 text-end">
                                        <button
                                            className="btn btn-secondary"
                                            onClick={() => navigate("/payslip/allpayslip")}
                                        >
                                            <i className="fa fa-arrow-left"></i> Back
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6 mb-3">
                                            <label className="form-label">
                                                Staff Member <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                options={staffList}
                                                value={staffList.find((opt) => opt.value === formData.staff_id)}
                                                onChange={handleStaffChange}
                                                placeholder="Select Staff"
                                                isDisabled={id ? true : false}
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">
                                                Month <span className="text-danger">*</span>
                                            </label>
                                            <Select
                                                options={months}
                                                value={months.find((opt) => opt.value === formData.month)}
                                                onChange={handleMonthChange}
                                                placeholder="Select Month"
                                                isDisabled={id ? true : false}
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">
                                                Year <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="year"
                                                value={formData.year}
                                                onChange={handleInputChange}
                                                min="2020"
                                                max="2100"
                                                disabled={id ? true : false}
                                            />
                                        </div>
                                    </div>

                                    <hr />
                                    <h5 className="mb-3">Earnings</h5>
                                    <div className="row">
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">
                                                Basic Salary <span className="text-danger">*</span>
                                            </label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="basic_salary"
                                                value={formData.basic_salary}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">HRA</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="hra"
                                                value={formData.hra}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Transport Allowance</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="transport_allowance"
                                                value={formData.transport_allowance}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Medical Allowance</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="medical_allowance"
                                                value={formData.medical_allowance}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>

                                        <div className="col-md-3 mb-3">
                                            <label className="form-label">Other Allowances</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="other_allowances"
                                                value={formData.other_allowances}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                    </div>

                                    <hr />
                                    <h5 className="mb-3">Deductions</h5>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Provident Fund (PF)</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="provident_fund"
                                                value={formData.provident_fund}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Tax Deduction</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="tax_deduction"
                                                value={formData.tax_deduction}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Other Deductions</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                name="other_deductions"
                                                value={formData.other_deductions}
                                                onChange={handleInputChange}
                                                step="0.01"
                                                min="0"
                                            />
                                        </div>
                                    </div>

                                    <hr />
                                    <h5 className="mb-3">Summary</h5>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Gross Salary</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                value={formData.gross_salary}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">Total Deductions</label>
                                            <input
                                                type="text"
                                                className="form-control bg-light"
                                                value={formData.total_deductions}
                                                readOnly
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                <strong>Net Salary</strong>
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control bg-success text-white"
                                                value={formData.net_salary}
                                                readOnly
                                            />
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mb-3">
                                            <label className="form-label">Remarks</label>
                                            <textarea
                                                className="form-control"
                                                name="remarks"
                                                value={formData.remarks}
                                                onChange={handleInputChange}
                                                rows="3"
                                            ></textarea>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 text-end">
                                            <button
                                                type="button"
                                                className="btn btn-secondary me-2"
                                                onClick={() => navigate("/payslip/allpayslip")}
                                            >
                                                Cancel
                                            </button>
                                            <button type="submit" className="btn btn-primary">
                                                <i className="fa fa-save"></i>{" "}
                                                {id ? "Update Payslip" : "Generate Payslip"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
